import { ANALYTICS_BI_VOCABULARIES } from './analytics-bi.js';
import { ARRIVAL_ALERT_VOCABULARIES } from './arrival-alert.js';
import { PICKUP_CHANGE_VOCABULARIES } from './pickup-change.js';
import { DESTINATION_CHANGE_VOCABULARIES } from './destination-change.js';
import { D713_GOVERNED_RULES_VOCABULARIES } from './d713-governed-rules.js';
import { D717_ACCOUNT_RULES_VOCABULARIES } from './d717-account-rules.js';
// D718 (doc 29 gap G4): the rider's signed-in devices.
import { RIDER_SESSIONS_VOCABULARIES } from './rider-sessions.js';
import { D721_HELP_CENTER_VOCABULARIES } from './d721-help-center.js';
import { D813_RIDE_CHAT_MEDIA_VOCABULARIES } from './d813-ride-chat-media.js';
import { DRIVER_REFERRAL_VOCABULARIES } from './driver-referral.js';
import { D726_IDENTITY_VERIFICATION_VOCABULARIES } from './d726-identity-verification.js';
import { D725_RIDER_PHOTO_VOCABULARIES } from './d725-rider-photo.js';
// D805: the operator's own profile (language, photo, password, sessions).
import { D805_OPERATOR_PROFILE_VOCABULARIES } from './d805-operator-profile.js';
import { D724_DRIVER_RECRUITMENT_VOCABULARIES } from './d724-driver-recruitment.js';
// D740: the rider's own Send.
import { D740_RIDER_SEND_VOCABULARIES } from './d740-rider-send.js';
import { ANALYTICS_EXPORT_VOCABULARIES } from './analytics-export.js';
import { BILLING_PARTNER_VOCABULARIES } from './billing-partner.js';
import { COURIER_DELIVERY_VOCABULARIES } from './courier-delivery.js';
import { DRIVER_HINTS_VOCABULARIES } from './driver-hints.js';
import { DRIVER_ONBOARDING_VOCABULARIES } from './driver-onboarding.js';
import { FARE_NEGOTIATION_VOCABULARIES } from './fare-negotiation.js';
import { FOOD_MERCHANT_VOCABULARIES } from './food-merchant.js';
import { FOOD_OPERATIONS_VOCABULARIES } from './food-operations.js';
import { PLATFORM_MISC_VOCABULARIES } from './platform-misc.js';
import { PROBLEM_SHARED_C_VOCABULARIES } from './problem-shared-c.js';
import { RIDE_POLICY_VOCABULARIES } from './ride-policy.js';
import { SAFETY_INCIDENTS_VOCABULARIES } from './safety-incidents.js';
/** Slice c of the catalog (D577): the domain files one build front owns register here (keeps fronts off each other's files). */
export const SLICE_C = [
    ...ANALYTICS_BI_VOCABULARIES,
    ...ANALYTICS_EXPORT_VOCABULARIES,
    ...ARRIVAL_ALERT_VOCABULARIES,
    ...PICKUP_CHANGE_VOCABULARIES,
    // D817: how a mid-trip destination change is priced.
    ...DESTINATION_CHANGE_VOCABULARIES,
    ...D713_GOVERNED_RULES_VOCABULARIES,
    ...D717_ACCOUNT_RULES_VOCABULARIES,
    ...RIDER_SESSIONS_VOCABULARIES,
    ...D721_HELP_CENTER_VOCABULARIES,
    // D825 + D826: the ride chat's personal ready messages and voice messages.
    ...D813_RIDE_CHAT_MEDIA_VOCABULARIES,
    ...DRIVER_REFERRAL_VOCABULARIES,
    ...D726_IDENTITY_VERIFICATION_VOCABULARIES,
    ...D725_RIDER_PHOTO_VOCABULARIES,
    ...D805_OPERATOR_PROFILE_VOCABULARIES,
    ...D724_DRIVER_RECRUITMENT_VOCABULARIES,
    ...D740_RIDER_SEND_VOCABULARIES,
    ...BILLING_PARTNER_VOCABULARIES,
    ...COURIER_DELIVERY_VOCABULARIES,
    ...DRIVER_HINTS_VOCABULARIES,
    ...DRIVER_ONBOARDING_VOCABULARIES,
    ...FARE_NEGOTIATION_VOCABULARIES,
    ...FOOD_MERCHANT_VOCABULARIES,
    ...FOOD_OPERATIONS_VOCABULARIES,
    ...PLATFORM_MISC_VOCABULARIES,
    ...PROBLEM_SHARED_C_VOCABULARIES,
    ...RIDE_POLICY_VOCABULARIES,
    ...SAFETY_INCIDENTS_VOCABULARIES,
];
//# sourceMappingURL=slice-c.js.map